<template>
	<div class="table-footer">
		<div class="row">
			<div class="col-md-4">
				<span>Show</span>
				<select
					class="form-control"
					v-model="showPerPage"
					id="resultsPerPage"
					@change="showPerPageChanged"
				>
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
				</select>
				<span>Entries</span>
			</div>
			<div class="col-md-4 text-center">
				<!-- <span> Selected Ones</span>
                <button class="btn btn-danger" onclick="deleteCampaignGroup();">
                    <svg viewBox="0 0 8 8" class="icon fill-white">
                            <use
                            xlink:href="images/open-iconic.svg#trash"></use>
                        </svg>
                    Delete
				</button>-->
			</div>
			<div class="col-md-4 text-right">
				<a href="javascript:void(0)" v-if="currentPageNumber!=1" @click="getPreviousPageList()">Previous</a>
				<select
					class="form-control selectpicker"
					style="max-width:80px;"
					id="brandFilter"
					v-model="currentPageNumber"
					@change="getNewPageList()"
				>
					<option v-for="index in totalNoOfPages" :key="index" :value="index">{{index}}</option>
				</select>
				<a
					href="javascript:void(0)"
					v-if="(showPerPage == scrapperList.length) && (currentPageNumber!=totalNoOfPages)"
					@click="getNextPageList()"
				>Next</a>
				<div style="padding-right:0px;padding-top:5px">{{getCount()}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "CampaignGroupGridFooter",
		data() {
			return {
				totalNoOfPages: 1
			};
		},
		watch: {
			notificationCount() {
				this.calculateIndexPerPage();
			}
		},
		computed: {
			scrapperCount: {
				set(val) {
					this.$store.commit("asinScapper/updateScrapperCount",val);
				},
				get() {
					return this.$store.getters["asinScapper/receiveScrapperCount"];
				}
			},
			showPerPage: {
				set(val) {
					this.currentPageNumber = 1
					sessionStorage.setItem("asinScapper:showPerPage", val);
				},
				get() {
					if (sessionStorage.getItem("asinScapper:showPerPage")) {
						return sessionStorage.getItem("asinScapper:showPerPage");
					}
					return this.$store.state.showPerPage;
				}
			},
			currentPageNumber: {
				set(val) {
					this.$store.state.product.actionSelectionControl = false;
					this.$store.state.product.selectedProducts = []
					this.$store.state.currentPageNumber = val;
				},
				get() {
					return this.$store.state.currentPageNumber;
				}
			},
			scrapperList() {
				return this.$store.state.asinScapper.scrapperList;
			}
		},
		mounted() {
			this.calculateIndexPerPage();
		},
		methods: {
			calculateIndexPerPage() {
				this.totalNoOfPages = Math.ceil(
					this.scrapperCount / this.showPerPage
				);
			},
			getPreviousPageList() {
				if (this.currentPageNumber <= 1) {
					return;
				} else {
					this.currentPageNumber -= 1;
					this.$emit("getList");
				}
			},
			getNextPageList() {
				this.currentPageNumber += 1;
				this.$emit("getList");
			},
			getNewPageList() {
				this.$emit("getList");
			},
			getCount() {
				let pageCount = this.showPerPage * (this.currentPageNumber - 1);
				let extendedcount =
					parseInt(pageCount) + parseInt(this.scrapperList.length);
				//return	pageCount+1 + ' to ' + extendedcount;
				return (
					"Showing " +
					(pageCount + 1) +
					" to " +
					extendedcount +
					" results of " +
					this.scrapperCount
				);
			},
			showPerPageChanged() {
				this.$emit("getList");
			}
		}
	};
</script>

<style lang="scss">
</style>
